export default __webpack_public_path__ + "static/media/PaintingPenArtSchool-4.ff2bc385.jpg";